import { includes } from 'lodash';
import UserService from '@/services/UserService.js';
export default {
  state: {
    user: {},
    recurlyCode: '',
    isTruelifeMember: false,
    churchId: '',
    dashboardName: 'dashboard',
  },
  mutations: {
    UPDATE_USER(state, { user }) {
      state.user = user;
      if (includes(user.role, 'individual')) {
        state.dashboardName = 'individualDashboard';
      } else if (includes(user.role, 'care') && !includes(user.role, 'evangelism')) {
        state.dashboardName = 'careDashboard';
      } else if (includes(user.role, 'admin')) {
        state.dashboardName = 'AdminDashboard';
      } else {
        state.dashboardName = 'dashboard';
      }
    },
    LOGOUT_USER(state) {
      state.user = {};
      state.messages = [];
      state.recurlyCode = '';
      state.isTruelifeMember = false;
      state.churchId = '';
      state.dashboardName = 'dashboard';
    },
    UPDATE_ROLE(state, isTruelifeMember) {
      state.isTruelifeMember = isTruelifeMember;
    },
    UPDATE_RECURLY(state, recurlyCode) {
      state.recurlyCode = recurlyCode;
    },
    UPDATE_CHURCH_ID(state, churchId) {
      state.churchId = churchId;
    },
  },
  actions: {
    updateRole({ commit }, data) {
      commit('UPDATE_ROLE', data);
    },
    updateRecurlyCode({ commit }, data) {
      commit('UPDATE_RECURLY', data);
    },
    updateUser({ commit }, data) {
      commit('UPDATE_USER', data);
    },
    updateChurchId({ commit }, data) {
      commit('UPDATE_CHURCH_ID', data);
    },
    logout({ commit }) {
      commit('LOGOUT_USER');
    },
    async fetchUser({ commit }) {
      try {
        const userInfos = await UserService.doGetUserInfo1();
        commit('UPDATE_USER', {
          user: {
            ...this.state.user.user,
            accountId: userInfos.account_id,
            accountSlug: userInfos.account_slug,
            userId: userInfos.id,
            restricted: userInfos.restricted || userInfos.state !== 'active',
            churchName: userInfos.church_name,
            churchWebsite: userInfos.church_website,
            waitingVideos: userInfos.waiting_videos,
            newConnections: userInfos.new_connections,
            churchPhone: userInfos.church_phone,
            churchStatus: userInfos.church_status,
            photo_url: userInfos.photo_url,
            membership: userInfos.membership,
            shippingInfo: userInfos.shipping_address,
            inviteVideo: userInfos.invite_video,
            inviteChurchLogo: userInfos.invite_church_logo,
            story: userInfos.story,
            profileVideo: userInfos.profile_video,
          },
        });
      } catch (e) {}
    },
  },
  getters: {
    user: state => state.user,
    dashboardName: state => state.dashboardName,
  },
};
